import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';

@Component({
    selector: 'financial-knowledge8',
    templateUrl: './financial-knowledge8.component.html',
    styleUrls: ['./financial-knowledge8.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class FinancialKnowledge8Component implements OnInit {
  @Input() derrors = false;
  options: FormControlOption[] = [
    {
      value: 'CASE_A',
      label: 'Choix A',
      suffix: { title: 'A' },
    },
    {
      value: 'CASE_B',
      label: 'Choix B',
      suffix: { title: 'B' },
    },
  ];
  constructor() {}

  ngOnInit() {}
}
